//export const imgHttpFolder='http://localhost/wwwl/09_igor/web/00_git/xtal-project/02_part_react_v3/public/pimages'
export const imgHttpFolder='http://test.art-timing.com/public/pimages'
export const imgPathClockTimerRtcc22 ='./pimages/types200/type6_200px.png'
export const imgPathClockTimerUsfr22 ='./pimages/types200/type7_200px.png'
export const imgPathXbc ='./pimages/types200/type15_200px.png'
export const imgPathXbcXls ='./pimages/spec_case_pinout/XBC_case700x500.png'